/* eslint-disable */

'use strict';

const urlParams = new URLSearchParams(window.location.search);

/* Zapier Webhooks */
window.addEventListener('load', function () {
    /* Zapier Webhooks */
    if (!!form_sources_js_vars.zapierWebhookUrl) {
        let params = {
            email: getUrlParam('email')
        };

        if (getUrl() === window.location.origin + '/erfolgreich-angemeldet') {
            sendZapierHook(params, form_sources_js_vars.zapierWebhookUrl);
        }
    }
    if (!!form_sources_js_vars.zapierWebhookUrlHrNl) {
        let params = {
            FNAME: getUrlParam('FNAME'),
            LNAME: getUrlParam('LNAME'),
            EMAIL: getUrlParam('EMAIL'),
            TEL: getUrlParam('TEL'),
            QF: getUrlParam('QF'),
            AT: getUrlParam('AT')
        };

        if (getUrl() === window.location.origin + '/hr-newsletter/erfolgreich-angemeldet') {
            sendZapierHook(params, form_sources_js_vars.zapierWebhookUrlHrNl);
        }
    }
});

/**
 * Send Zapier Hook
 * @param params
 */
function sendZapierHook(params, zapierWebhook) {
    fetch(zapierWebhook, {
        method: 'POST',
        body: JSON.stringify(params)
    }).then(res => res.json())
        .then(res => console.log(res));
}

/**
 * @param param
 * @returns {string|string}
 */
function getUrlParam(param) {
    return urlParams.get(param) ? urlParams.get(param) : ''
}

/**
 * Get current URL
 * @returns {string}
 */
function getUrl() {
    return window.location.origin + window.location.pathname.replace(/\/$/, '');
}


// WEBPACK FOOTER //
// ./scripts/form-sources.js